import * as React from 'react';
import {BREAKPOINTS, keycodes} from 'utilities';

export default class DesktopNewTabAnchor extends React.PureComponent<React.HTMLProps<HTMLAnchorElement>> {
  link = (event) => {
    if (window.matchMedia(`(min-width: ${BREAKPOINTS.desktop.min}px)`).matches) {
      event.preventDefault();
      window.open(event.currentTarget.href, '_blank');
    }
  };

  handleKeyDown = (event) => {
    if (event.keyCode === keycodes.ENTER) {
      this.link(event);
    }
  };

  render() {
    const {
      children,
      ...otherProps
    } = this.props;

    return (
      <a
        {...otherProps}
        onClick={this.link}
        onKeyDown={this.handleKeyDown}
      >
        {children}
      </a>
    );
  }
}
